import TabComponent from "../../../components/navComponents/TabComponent";
import { useDashboardStore, useDashboardDispatch } from "../../../contexts/single-dashboard/DashboardContext";
import { useUpdateDashboard } from "../../../apiCalls/dashboards";
import { useUpdateLoaderData } from "../../../contexts/DashboardSlots";

export default function DashboardTab() {
  const {editedDashboard} = useDashboardStore();
  const { updateDashboard } = useUpdateDashboard();
  const dashboardDispatch = useDashboardDispatch();
  const loaderDataDispatch = useUpdateLoaderData();

  const handleTitleChange = async(newTitle) => {
    let updatedDash = {...editedDashboard, title: newTitle};
    const returnDash = await updateDashboard({id: editedDashboard.id, title: newTitle});
    if(returnDash?.id){
      dashboardDispatch({type: "setEditedDashboard", payload: updatedDash});
      loaderDataDispatch({type: "updateDashboard", payload: updatedDash});
    }
  }

  return (
    <TabComponent
        key='dashboard'
        title={editedDashboard.title}
        classType={"Dashboard"}
        handleTitleChange={handleTitleChange}
    />
  )
}